import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/table';
import'rxjs/add/operator/map';
import'rxjs/add/operator/switchMap';
import'rxjs/add/observable/fromEvent';
import'rxjs/add/observable/merge';
import'rxjs/add/observable/of';
import'rxjs/add/operator/debounceTime';
import'rxjs/add/operator/distinctUntilChanged';
import { MatPaginator, MatSort } from '@angular/material';
import { ElementRef } from '@angular/core';

export interface Pagination {
      pageIndex: number;
      pageSize: number;
      length: number;
}

export interface Sort {
      active: string;
      direction: string;
}
export class TableAdapter extends DataSource<any> {

      tableData = new BehaviorSubject<{}[]>([]);
      sourceData = new BehaviorSubject<{}[]>([]);
      displayedColumns = [];
      searchColumns = [];
      pagination = new BehaviorSubject<Pagination>({
            pageIndex: 0,
            pageSize: 10,
            length: this.tableData.value.length
      });
      filter = new BehaviorSubject<String>('');
      sort = new BehaviorSubject<Sort>({
            active: '',
            direction: 'asc'
      });
/**
 * @param {?} _data
 * @param {?=} _displayedColumns
 * @param {?=} _paginator
 * @param {?=} _sort
 * @param {?=} _searchColumns
 * @param {?=} _filterInput
 */
constructor(
private _data: any,
private _displayedColumns?: string[],
private _paginator?: MatPaginator,
private _sort?: MatSort,
private _searchColumns?: string[],
private _filterInput?: ElementRef
      ) {
            super();
            if (_searchColumns && _searchColumns.length === 0) {
                  _searchColumns = _displayedColumns;
            }

            if (_filterInput) {
                  Observable.fromEvent(_filterInput.nativeElement, 'keyup')
                        .debounceTime(100)
                        .distinctUntilChanged()
                        .subscribe(() => this.filter.next(_filterInput.nativeElement.value));
            }

      }
/**
 * Connect function called by the table to retrieve one stream containing the data to render.
 * @return {?}
 */
connect(): Observable<any> {
            const /** @type {?} */ connectData = [];
            if (this._filterInput) {
                  connectData.push(this.filter);
            }
            if (this._sort) {
                  connectData.push(this._sort.sortChange);
            }
            if (this._paginator) {
                  connectData.push(this._paginator.page);
            }

            return this._data
                  .map((res) => this.setData(res))
                  .switchMap(res => {
                        if (connectData.length > 0) {
                              return Observable.merge(...connectData);
                        } else {
                              return Observable.of(res);
                        }
                  })
                  .map(() => this.filtering())
                  .map(() => this.sorting())
                  .map(() => this.paging());
      }
/**
 * @param {?} data
 * @return {?}
 */
setData(data: any[]) {
            this.sourceData.next(data);
            this.tableData.next(data);
            if (this._paginator) {
                  this._paginator.length = this.tableData.value.length;
            }
      }
/**
 * @return {?}
 */
paging() {
            if (this._paginator) {
                  this._paginator.length = this.tableData.value.length;
                  const /** @type {?} */ data = this.tableData.value.slice();

                  const /** @type {?} */ startIndex = this._paginator.pageIndex * this._paginator.pageSize;
                  return data.splice(startIndex, this._paginator.pageSize);
            } else {
                  return this.tableData.value;
            }
      }
/**
 * @return {?}
 */
sorting() {
            const /** @type {?} */ data = this.tableData.value.slice();
            if (!this._sort || !this._sort.active || this._sort.direction === '') {
                  return this.tableData.value;
            }

            data.sort((a, b) => {
                  let /** @type {?} */ propertyA: number | string = '';
                  let /** @type {?} */ propertyB: number | string = '';

                  [propertyA, propertyB] = [a[this._sort.active], b[this._sort.active]];

                  const /** @type {?} */ valueA = isNaN(+propertyA) ? propertyA : +propertyA;
                  const /** @type {?} */ valueB = isNaN(+propertyB) ? propertyB : +propertyB;

                  return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
            });
            this.tableData.next(data);
            return data;
      }
/**
 * @return {?}
 */
filtering() {
            if (!this._filterInput) {
                  return this.tableData.value;
            }
            if (this.filter.value === '') {
                  this.tableData.next(this.sourceData.value);
                  return this.sourceData.value;
            }
            const /** @type {?} */ query: string[] = this.filter.value.split(' ');
            let /** @type {?} */ tableData = this.sourceData.value;
            query.forEach(q => {
                tableData = tableData.slice().filter((item) => {
                    let /** @type {?} */ exist = false;
                    let /** @type {?} */ result = -1;
                    this._searchColumns.forEach(obj => {
                        if (typeof item[obj] === 'string') {
                            if (typeof item[obj] !== 'undefined' && typeof query !== 'undefined') {
                                const /** @type {?} */ searchStr = item[obj].toLowerCase();
                                result = searchStr.indexOf(q.toLowerCase());
                            }
                        } else if (typeof item[obj] !== 'undefined' && typeof this.filter.value !== 'undefined') {
                            const /** @type {?} */ searchStr2 = item[obj].toString();
                            result = searchStr2.indexOf(q);
                        }
                        if (result !== -1) {
                            exist = true;
                        }
                    });
                    return exist;
                });
            });
            this.tableData.next(tableData);
            this._paginator.pageIndex = 0;
            this._paginator.length = tableData.length;
            return tableData;
      }
/**
 * @return {?}
 */
disconnect() { }

}

function TableAdapter_tsickle_Closure_declarations() {
/** @type {?} */
TableAdapter.prototype.tableData;
/** @type {?} */
TableAdapter.prototype.sourceData;
/** @type {?} */
TableAdapter.prototype.displayedColumns;
/** @type {?} */
TableAdapter.prototype.searchColumns;
/** @type {?} */
TableAdapter.prototype.pagination;
/** @type {?} */
TableAdapter.prototype.filter;
/** @type {?} */
TableAdapter.prototype.sort;
/** @type {?} */
TableAdapter.prototype._data;
/** @type {?} */
TableAdapter.prototype._displayedColumns;
/** @type {?} */
TableAdapter.prototype._paginator;
/** @type {?} */
TableAdapter.prototype._sort;
/** @type {?} */
TableAdapter.prototype._searchColumns;
/** @type {?} */
TableAdapter.prototype._filterInput;
}
